var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"text_center"},[_c('h2',{staticClass:"header_underline"},[_vm._v("LINE登録エラー")]),_vm._m(0),_c('p',[_c('router-link',{staticClass:"decoration_link_arrow_blue",attrs:{"to":{ name: 'Top' }}},[_vm._v("トップページへ戻る")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("LINE登録時にエラーが発生しました。"),_c('br'),_vm._v("ご迷惑をおかけしますが時間をおいて再度お試しください。")])
}]

export { render, staticRenderFns }